
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[technology]",
      function () {
        return require("private-next-pages/blog/[technology]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[technology]"])
      });
    }
  